import { render, staticRenderFns } from "./myDownload.vue?vue&type=template&id=e53a342a&scoped=true&"
import script from "./myDownload.vue?vue&type=script&lang=js&"
export * from "./myDownload.vue?vue&type=script&lang=js&"
import style0 from "./myDownload.vue?vue&type=style&index=0&id=e53a342a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a342a",
  null
  
)

export default component.exports